// AdSense Configuration
// To disable ads, set REACT_APP_ADSENSE_ENABLED=false in your .env file
// or change the default value below

const AD_CONFIG = {
  // Enable/disable all ads - can be overridden by environment variable
  enabled: false, // Temporarily disabled until AdSense approval complete
  
  // AdSense client ID
  clientId: process.env.REACT_APP_ADSENSE_CLIENT_ID || 'ca-pub-5429287039814597',
  
  // Ad placements configuration
  placements: {
    topBanner: {
      enabled: false, // Disabled - too intrusive
      slot: '5532526373',
      format: 'fluid',
      layoutKey: '-fb+5w+4e-db+86'
    },
    inFeed: {
      enabled: true,
      slot: '5532526373', // Using same slot for now
      format: 'fluid',
      layoutKey: '-fb+5w+4e-db+86',
      frequency: 4 // Show ad after every 4th event
    }
  },
  
  // Debug mode - shows placeholder ads in development  
  debug: true // Keeping enabled until AdSense approval is complete
};

export default AD_CONFIG;
